

import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';


const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: 'rgba(18, 196, 92,0.6)',
            hoverBackgroundColor: 'rgba(18, 196, 92,0.8)',
            data: [65, 59, 80, 81, 56, 55, 40]
        }
    ]
};



class BarChart extends Component {
    render() {


        return (
            <div>
                <div className="card main-shadow"  >
                    <h4 className="text-center">{this.props.title}</h4>
                    <Bar
                        data={data}

                        options={{
                            maintainAspectRatio: true
                        }}
                    />

                </div>

            </div>

        );
    }
}

export default BarChart;
